import { OrganisationEntity } from "Models/Entities";
import { store } from "Models/Store";
import { useState } from "react";
import { ComboboxOption } from "../Combobox/Combobox";
import { BusinessEntitySelection } from "./BusinessEntitySelection";
import { PaymentDetailForm } from "./PaymentDetailForm";
import alertToast from "Util/ToastifyUtils";
import If from "../If/If";
import { fetchClientSecret } from "Hooks/Api/apiStripe";
import { StripeScriptLoader } from "./StripeLoader";

type Props = {
	organisation: OrganisationEntity,
	businessEntityId?: string | undefined,
	redirectUrl: string,
	onCancel?: () => void
}

export const SetupPaymentSection: React.FunctionComponent<Props> = ({
	organisation,
	businessEntityId,
	redirectUrl,
	onCancel
}) => {
	const [selectedBusinessEntityIds, setSelectedBusinessEntityIds] = useState<string[]>([]);
	const [clientSecret, setClientSecret] = useState<string>();

	const hasPermission =
		store.userType === "SUPER_USER" ||
		store.userType === "ORGANISATION_MANAGER" ||
		store.userType === "ADMIN";

	if (businessEntityId) {
		fetchClientSecret(organisation.id, [businessEntityId], redirectUrl).then(response => {
			setClientSecret(response);
		})
	}

	const retrieveAvailableBusinessEntities = () => {
		const result: ComboboxOption<string>[] = [];
		if (organisation.businessEntitys.length > 1) {
			result.push({
				display: "All",
				value: "all",
			});
		}

		organisation.businessEntitys.forEach(businessEntity => {
			result.push({
				display: businessEntity.name,
				value: businessEntity.id,
			});
		});

		return result;
	}

	const onCancelBusiness = () => {
		setClientSecret(undefined);
		onCancel?.();
	}

	const onAfterSelectionBusiness = async () => {
		try {
			const response = await fetchClientSecret(
				organisation.id,
				selectedBusinessEntityIds,
				redirectUrl
			);
			if (response) {
				setClientSecret(response);
			}

		} catch (error) {
			alertToast("Failed to initiate payment setup. Please try again", "error");
			setClientSecret(undefined);
		}
	}

	if (!hasPermission) {
		return (
			<div className="content">
				To add payment Details. Please contact your admin or organisation manager
			</div>
		)
	}

	return (
		<>
			<StripeScriptLoader />
			<If condition={!businessEntityId && !clientSecret}>
				<BusinessEntitySelection
					businessEntityIds={selectedBusinessEntityIds}
					setBusinessEntityIds={setSelectedBusinessEntityIds}
					availableBusinessEntities={retrieveAvailableBusinessEntities()}
					onCancel={onCancelBusiness}
					afterSelection={onAfterSelectionBusiness}
				/>
			</If>
			{clientSecret && <PaymentDetailForm clientSecret={clientSecret} onCancel={onCancel} />}
		</>
	)
}

